import React from "react";
import { Text, View } from "native-base";
import { webFont } from "../../../Universal/API/API";

type EmptyStateProps = {
  scaleAll: number;
};

const EmptyState: React.FC<EmptyStateProps> = ({ scaleAll }) => {
  return (
    <View
      style={{
        borderRadius: 18 * scaleAll,
        backgroundColor: "#FBFAF8",
        borderWidth: 1,
        borderColor: "#ECE8E1",
        padding: 16 * scaleAll,
      }}
    >
      <Text
        selectable={false}
        style={{
          fontFamily: webFont("Inter"),
          fontSize: 13 * scaleAll,
          color: "#6E665D",
          fontWeight: "600",
        }}
      >
        По текущим фильтрам заказы не найдены.
      </Text>
    </View>
  );
};

export default React.memo(EmptyState);
